import { SERVICES } from '@/data/site';
import { SERVICES_SEO } from '@/data/services';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { ServicesHero } from '@/components/site/services/ServicesHero';
import { ServiceAreas } from '@/components/site/services/ServiceAreas';
import { ChallengeFinder } from '@/components/site/services/ChallengeFinder';
import { ServicesDirectory } from '@/components/site/services/ServicesDirectory';
import { EcosystemPromo } from '@/components/site/services/EcosystemPromo';
import { HowAmdenWorks } from '@/components/site/services/HowAmdenWorks';
import { NotSurePanel } from '@/components/site/services/NotSurePanel';
import { ServicesCaseStudies } from '@/components/site/services/ServicesCaseStudies';
import { CtaBand } from '@/components/site/CtaBand';

export default function ServicesPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: SERVICES_SEO.title,
    description: SERVICES_SEO.description,
    canonical: `${origin}/services`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
            { '@type': 'ListItem', position: 2, name: 'Services', item: `${origin}/services` },
          ],
        },
        {
          // The four service areas — verified names/routes only.
          '@type': 'ItemList',
          name: 'Amden Group service areas',
          itemListElement: SERVICES.map((s, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            item: {
              '@type': 'Service',
              name: s.name,
              description: s.description,
              url: `${origin}${s.href}`,
              provider: { '@type': 'Organization', name: 'Amden Group', url: origin },
            },
          })),
        },
      ],
    },
  });

  return (
    <>
      <ServicesHero />
      <ServiceAreas />
      <ChallengeFinder />
      <ServicesDirectory />
      <EcosystemPromo />
      <HowAmdenWorks />
      <NotSurePanel />
      <ServicesCaseStudies />
      <CtaBand
        index="09"
        eyebrow="Next step"
        heading="Ready to strengthen your business?"
        copy="Tell us where you need support, and we’ll help identify the most practical next step."
        primaryLabel="Discuss Your Business"
        primaryHref="/?source=Services%20Overview#solution-finder"
        secondaryLabel="Book an Appointment"
        secondaryHref="/contact#book-appointment"
      />
    </>
  );
}
